<template>
    <v-page-data-table
            title="接口管理"
            key-name="id"
            :fields="fields"
            ref="rest"
            @refresh="onRefresh"
            :height="535"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="REST_DELETE"
            query-api="REST_QUERY">

        <template v-slot:path="{item}">
            <v-link-text :text="item.path" @click="onDetail(item)"></v-link-text>
        </template>

        <template v-slot:protectLevel="{item}">
            <v-btn @click="onChangeLevel(item)" text tile small v-if="item.protectLevel=='PROTECT'">
                <v-icon small>mdi-lock</v-icon>
                保护
            </v-btn>
            <v-btn @click="onChangeLevel(item)" text tile small v-if="item.protectLevel=='PUBLIC'">
                <v-icon small>mdi-lock-open</v-icon>
                公开
            </v-btn>
        </template>
    </v-page-data-table>
</template>

<script>
    import FndUserQueryFields from "./fields/FndRestQuery";
    import _ from 'lodash';

    export default {
        name: "ProducerQuery",
        data() {
            return {
                fields: FndUserQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '刷新接口列表',
                        color: 'primary',
                        icon: "mdi-refresh",
                        action: 'refresh'
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("restDetail", {id: id});
            },
            onRefresh() {
                this.$request.request("REST_REFRESH").then(response => {
                    this.$refs.rest.query();
                })
            },
            onChangeLevel(item) {
                let level = "PUBLIC";
                if (item.protectLevel == 'PUBLIC') {
                    level = "PROTECT";
                }
                this.$request.request("REST_CHANGE_LEVEL", {rowid: item.id, level: level}).then(response => {
                    item.protectLevel = level;
                    this.$message.success("更新成功");
                })
            }
        }
    }
</script>
